import React from 'react';
import chroma from 'chroma-js';
import { styled, TextV2 } from '@withjoy/joykit';
import { IMenuItem } from './WorkspaceMenu';
import { INavTheme } from './NavThemes';
import { NavigationWrapper } from './components/NavigationWrapper';

const ICON_SIZE = '54px';

const Item = styled.div<{}>`
  width: 100px;
  height: 100px;
  overflow: hidden;
  padding: 8px;
  text-align: center;
  color: #1a1a1a;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 19.6px */
  letter-spacing: -0.035px;
  user-select: none;
`;
const ColoredCircle = styled.button<{ color: string; highlightColor: string; shadedColor: string; shadowColor: string; background?: string }>`
  width: ${ICON_SIZE};
  height: ${ICON_SIZE};
  border-radius: 50%;
  margin: auto;
  background: ${props => (props.background ? props.background : `linear-gradient(180deg, ${props.color} 0%, ${props.shadedColor} 100%)`)};
  box-shadow: 0px 1px 1px ${props => props.shadowColor};
  user-select: none;
  transition: all 0.2s ease-in-out;
  transition-delay: 0ms;
  cursor: pointer;
  &:hover,
  &:focus {
    transform: scale(1.02);
    box-shadow: 0px 1px 2px ${props => props.shadowColor};
  }
`;

const ItemIcon = styled.img`
  width: ${ICON_SIZE};
  height: ${ICON_SIZE};
`;

interface IMenuItemProps extends IMenuItem {
  onMenuItemClick?: (item: IMenuItem) => void;
  theme: INavTheme;
}

export const MenuItem: React.FC<IMenuItemProps> = ({ label, color, background, iconUrl, link, route, keywords, onMenuItemClick, theme, description }) => {
  const shadowColor = chroma(color.end).darken(2).toString();
  const hoverColor = chroma(color.start).brighten(0.5).toString();
  const handleNavigate = () => {
    if (onMenuItemClick) {
      onMenuItemClick({ label, color, iconUrl, link, keywords });
    }
  };

  return (
    <NavigationWrapper
      link={link}
      route={route || ''}
    >
      <Item title={description ?? ''}>
        <ColoredCircle
          type="button"
          color={color.start}
          highlightColor={hoverColor}
          shadedColor={color.end}
          shadowColor={shadowColor}
          background={background}
          onClick={handleNavigate}
        >
          {iconUrl && (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <ItemIcon
                src={iconUrl}
                title={''}
                alt=""
                style={{}}
              />
            </div>
          )}
        </ColoredCircle>
        <TextV2
          typographyVariant={'label1'}
          color={theme.font}
          fontWeight={600}
          marginTop={'6px'}
        >
          {label}
        </TextV2>
      </Item>
    </NavigationWrapper>
  );
};
